// Runs before attribution scripts. Credentials live only in this closure, never in history state.
export const CLAIM_LINK_BOOTSTRAP = String.raw`(() => {
  let pending;
  const isClaim = pathname => /^\/(?:plans\/[^/]+\/)?tickets\/claim\/?$/.test(pathname);
  const clean = value => {
    const url = new URL(value, location.href);
    if (!isClaim(url.pathname)) { pending = undefined; return url.href; }
    const token = new URLSearchParams(url.hash.slice(1)).get("token");
    if (token) pending = { path: url.pathname, token };
    url.hash = "";
    url.searchParams.delete("token");
    return url.href;
  };
  const replace = history.replaceState.bind(history);
  const scrub = () => {
    const original = location.href;
    const cleaned = clean(original);
    if (cleaned !== original) replace(history.state, "", cleaned);
    window.dispatchEvent(new Event("butter:claim-link"));
  };
  window.__butterTakeClaimLink = () => { const value = pending; pending = undefined; return value; };
  for (const method of ["pushState", "replaceState"]) {
    const original = history[method].bind(history);
    history[method] = (state, unused, url) => {
      const cleaned = url == null ? url : clean(String(url));
      original(state, unused, cleaned);
      window.dispatchEvent(new Event("butter:claim-link"));
    };
  }
  window.addEventListener("hashchange", scrub);
  window.addEventListener("popstate", scrub);
  scrub();
})();`;

declare global {
  interface Window {
    __butterTakeClaimLink?: () => { path: string; token: string } | undefined;
  }
}

let link: { path: string; token: string } | undefined;
let revision = 0;
let initialized = false;
const listeners = new Set<() => void>();
function receive() {
  const pending = window.__butterTakeClaimLink?.();
  if (!pending) {
    if (link && link.path !== window.location.pathname) {
      link = undefined;
      revision++;
      for (const listener of listeners) listener();
    }
    return;
  }
  link = pending;
  revision++;
  for (const listener of listeners) listener();
}
export function initializeClaimLink() {
  if (initialized) return;
  initialized = true;
  receive();
  window.addEventListener("butter:claim-link", receive);
}
export function claimLinkToken(path: string) {
  return link?.path.replace(/\/$/, "") === path.replace(/\/$/, "")
    ? link.token
    : undefined;
}
export function forgetClaimLink() {
  link = undefined;
}
export function claimLinkRevision() {
  return revision;
}
export function subscribeClaimLink(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
